import api from "./apiClient";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const PATH = `${BASE_URL}/api/v1/salary-bonus-expenses`;

class ExpensesSalaryBonusService {
  async getAll(year?: number) {
    const params = year ? { year } : {};
    return api.get(PATH, { params }).then((response: any) => response.data);
  }

  async getList(page: any) {
    return api.post(`${PATH}/list`, page).then((response: any) => response.data);
  }

  async getById(uuid: string) {
    return api.get(`${PATH}/${uuid}`).then((response: any) => response.data);
  }

  async create(payload: { academicYear: number }) {
    return api.post(PATH, payload).then((response: any) => response.data);
  }

  async update(uuid: string, payload: any) {
    return api.put(`${PATH}/${uuid}`, payload).then((response: any) => response.data);
  }

  async exportExcel(uuid: string) {
    return api.post(`${PATH}/generate/xls/${uuid}`, {}, { responseType: 'blob' });
  }

  async deleteById(uuid: string) {
    return api.delete(`${PATH}/${uuid}`).then((response: any) => response.data);
  }
}

export default new ExpensesSalaryBonusService();
